export default {
    component: () => import('./index'),
    meta: {
        nav: {
            title: '关于我们'
        }
    }
};
